import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { submissionsApi } from '@api';
import { CreateSubmissionDto } from '@app-types';

const useCreateSubmission = (options?: UseMutationOptions<AxiosResponse, unknown, CreateSubmissionDto>) => {
  return useMutation({
    ...options,
    mutationFn: submissionsApi.createSubmission,
  });
};

export default useCreateSubmission;
